import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useApp from "../context/AppContext";
import Header from "../component/Header";
import { api } from "../utils/api";
import InputPedidos from "../component/InputPedidos";
import { Tag } from "react-tag-input";
import { PedidoCompra } from "../types";

const InserirDocumento = () => {
  const { usuario, setUsuario, setLoading, showModalError, setItens, setPedidos } = useApp();
  const refAnexo = useRef<HTMLInputElement>(null);
  const refAnexoBoleto = useRef<HTMLInputElement>(null);
  const refAnexoCarta = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const [showPedidoHelp, setShowPedidoHelp] = useState(false);
  const [showNotaHelp, setShowNotaHelp] = useState(false);
  const [tipoDocumento, setTipoDocumento] = useState("Fatura");
  const [numeroNota, setNumeroNota] = useState("");
  const [sended, setSended] = useState(false);
  const [anexo, setAnexo] = useState({} as File);
  const [anexoBoleto, setAnexoBoleto] = useState({} as File);
  const [anexoCarta, setAnexoCarta] = useState({} as File);
  const [descricao, setDescricao] = useState("");
  const [pedidosSug, setPedidosSug] = useState<Tag[]>(new Array<Tag>());
  const [pedidosSel, setPedidosSel] = useState<Tag[]>(new Array<Tag>());

  const handleAdicionaPedido = (tag: Tag) => {
    const duplicated = pedidosSug?.filter((sug) => sug.id === tag.id);
    if (duplicated?.length !== 0) {
      const newSelection = [...pedidosSel, { ...tag }];
      setPedidosSel(newSelection);
    } else {
      alert("Pedido não consta na lista!");
    }
  };
  const handleRemovePedido = (id: number) => {
    const removed = pedidosSel?.filter((sug, i) => i !== id);
    setPedidosSel(removed);
  };
  const handleInsereFatura = () => {
    const pedidosSelecionados = pedidosSel.map((ped) => parseInt(ped.text));
    const doc = {
      descricao,
      numeroNota,
      pedidos: pedidosSelecionados,
      nota: anexo,
      tipo: tipoDocumento,
      anexo_Boleto: anexoBoleto,
      anexo_Carta: anexoCarta,
    };
    if (pedidosSelecionados.length === 0) return showModalError("Insira o pedido de compra");
    setLoading(true);
    api(usuario)
      .post("/notasServico/pegaItensFatura", doc)
      .then((resp) => {
        if (resp.status === 200) {
          setLoading(false);
          setItens(resp.data);
          const user = { ...usuario };
          user.novoDocumento = doc;
          setUsuario(user);
          navigate("/inserirItensDocumento");
        } else {
          setLoading(false);
          showModalError(resp.data);
        }
      })
      .catch(function (error) {
        setLoading(false);
        if (typeof error.response.data === "string") showModalError(error.response.data);
        else {
          if (error.response.status === 406) localStorage.clear();
          showModalError("Erro ao acessar servidor");
        }
      });
  };
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    if (
      descricao.length > 0 &&
      pedidosSel.length > 0 &&
      numeroNota.length > 0 &&
      (tipoDocumento === "Fatura" || refAnexo.current?.files?.length)
    )
      handleInsereFatura();
    else setSended(true);
    event.preventDefault();
  };
  const handleGetPedidos = () => {
    setLoading(true);
    api(usuario)
      .get("/notasServico/pegaPedidosAbertos")
      .then((resp) => {
        if (resp.status === 200) {
          setLoading(false);
          setPedidos(resp.data);
          setPedidosSug(
            resp.data.map((ped: PedidoCompra, i: number) => {
              return { id: i.toString(), text: ped.idPedido.toString() };
            })
          );
        }
      });
  };

  const InputBoleto = (
    <div className="form-row mb-3">
      <div className="form-group">
        <label className="form-label mb-1">Boleto (pdf)</label>
        <input
          type="file"
          className={`${anexoBoleto && sended ? "is-invalid" : "borda-cinza"}`}
          ref={refAnexoBoleto}
          accept="application/pdf"
          onChange={(e) => {
            if (refAnexoBoleto.current?.files && refAnexoBoleto.current.files[0] !== undefined) {
              if (refAnexoBoleto.current.files[0].size > 1.5 * 1024 * 1024) {
                window.alert("Tamanho máximo ultrapassado!");
                refAnexoBoleto.current.value = "";
              } else setAnexoBoleto(refAnexoBoleto.current?.files[0]);
            }
          }}
        />      
        <small className="form-text text-muted">Tamanho máximo: 1.5MB</small>
        <div
          className="invalid-feedback mb-3 bold"
          style={{ display: refAnexoBoleto.current?.files?.length === 0 && sended ? "contents" : "none" }}
        ></div>
      </div>
    </div>
  );

  const InputCarta = (
    <div className="form-row mb-3">
      <div className="form-group">
        <label className="form-label mb-1">Carta de correção (pdf)</label>
        <input
          type="file"
          className={`${anexoCarta && sended ? "is-invalid" : "borda-cinza"}`}
          ref={refAnexoCarta}
          accept="application/pdf"
          onChange={(e) => {
            if (refAnexoCarta.current?.files && refAnexoCarta.current.files[0] !== undefined) {
              if (refAnexoCarta.current.files[0].size > 1.5 * 1024 * 1024) {
                window.alert("Tamanho máximo ultrapassado!");
                refAnexoCarta.current.value = "";
              } else setAnexoCarta(refAnexoCarta.current?.files[0]);
            }
          }}
        />
        <div
          className="invalid-feedback mb-3 bold"
          style={{ display: refAnexoCarta.current?.files?.length === 0 && sended ? "contents" : "none" }}
        ></div>
      </div>
    </div>
  );

  useEffect(() => {
    handleGetPedidos();
    usuario?.novoDocumento?.tipo && setTipoDocumento(usuario?.novoDocumento?.tipo);
    usuario?.novoDocumento?.numeroNota && setNumeroNota(usuario?.novoDocumento?.numeroNota);
    usuario?.novoDocumento?.nota && setAnexo(usuario?.novoDocumento?.nota);
    usuario?.novoDocumento?.descricao && setDescricao(usuario?.novoDocumento?.descricao);
    if (usuario?.novoDocumento?.pedidos) {
      const pedidos = usuario?.novoDocumento?.pedidos.map((ped) => {
        const id = pedidosSug.find((tag) => tag.text === ped.toString())?.id || "0";
        return { id, text: ped.toString() };
      });
      setPedidosSel(pedidos);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario]);
  return (
    <>
      <div className="limiter altbg4">
        <div className="container-interna">
          <div className="wrap-interna p-t-25 p-b-20">
            <Header />
            <div className="wrap-insere-nota-fatura">
              <form onSubmit={handleSubmit} autoComplete="off">
                <h1 className="text-center pb-4">Inserir Nota Fiscal ou Fatura</h1>
                <div className="form-row mb-1">
                  <div className="form-group col-md-4">
                    <label className="mb-1">Tipo</label>
                    <select className="form-select mb-3" value={tipoDocumento} onChange={(e) => setTipoDocumento(e.target.value)}>
                      <option value="Nota Fiscal">Nota Fiscal</option>
                      <option value="Fatura">Fatura</option>
                    </select>
                  </div>
                </div>
                <div className="form-row mb-1 mt-3">
                  <div className="form-group col-md-8">
                    <label className="mb-1">Informe um ou mais pedidos de Compra da URBAM&nbsp;</label>
                    <div
                      className="popup circulo_interrogacao"
                      onClick={() => {
                        setShowPedidoHelp(!showPedidoHelp);
                      }}
                    >
                      ?
                      <span className={`popuptext ${showPedidoHelp ? "show" : ""}`} id="myPopup">
                        Número gerado pela URBAM localizado no canto superior direito do pedido de compra. Ao digitar tecle enter
                        para adicionar o número.
                      </span>
                    </div>
                    <InputPedidos
                      pedidos={pedidosSug}
                      selected={pedidosSel}
                      handleAdd={handleAdicionaPedido}
                      handleDel={handleRemovePedido}
                      tagInputField={`form-control ${pedidosSel.length === 0 && sended ? "is-invalid" : "borda-cinza"}`}
                    />

                    <div
                      className="invalid-feedback mb-3 bold"
                      style={{ display: pedidosSel.length === 0 && sended ? "contents" : "none" }}
                    >
                      <strong>Entre com o número do pedido! Campo obrigatório.</strong>
                    </div>
                  </div>
                </div>

                <div className="form-row mb-3 mt-3">
                  <div className="form-group">
                    <label className="mb-1">Descrição do Serviço</label>
                    <input
                      type="text"
                      className={`form-control col-12 ${descricao.length === 0 && sended ? "is-invalid" : "borda-cinza "}`}
                      placeholder="Informe a descrição do serviço prestado"
                      value={descricao}
                      onChange={(e) => setDescricao(e.currentTarget.value)}
                    />
                    <div
                      className="invalid-feedback bold"
                      style={{ display: descricao.length === 0 && sended ? "contents" : "none" }}
                    >
                      <strong>Entre com a descrição! Campo obrigatório.</strong>
                    </div>
                  </div>
                </div>

                {tipoDocumento === "Nota Fiscal" && (
                  <>
                    <div className="form-row mb-3">
                      <div className="form-group col-md-8">
                        <label className="mb-1 pr-2 mr-5">Número da Nota Fiscal&nbsp;</label>
                        <div
                          className="popup circulo_interrogacao"
                          onClick={() => {
                            setShowNotaHelp(!showNotaHelp);
                          }}
                        >
                          ?
                          <span className={`popuptext ${showNotaHelp ? "show" : ""}`} id="myPopup1">
                            Informe o número da Nota Fiscal Eletrônica presente no documento.
                          </span>
                        </div>
                        <input
                          type="text"
                          className={`form-control ${numeroNota.length === 0 && sended ? "is-invalid" : "borda-cinza "}`}
                          placeholder="Informe o número da nota"
                          value={numeroNota}
                          onChange={(e) => setNumeroNota(e.currentTarget.value)}
                        />
                        <div
                          className="invalid-feedback mb-3 bold"
                          style={{ display: numeroNota.length === 0 && sended ? "contents" : "none" }}
                        >
                          <strong>Entre com o número da nota! Campo obrigatório.</strong>
                        </div>
                      </div>
                    </div>
                    <div className="form-row mb-3">
                      <div className="form-group">
                        <label className="form-label mb-1">Nota Fiscal (pdf)*</label>
                        <input
                          type="file"
                          className={`${anexo && sended ? "is-invalid" : "borda-cinza"}`}
                          ref={refAnexo}
                          accept="application/pdf"
                          onChange={(e) => {
                            if (refAnexo.current?.files && refAnexo.current.files[0] !== undefined) {
                              if (refAnexo.current.files[0].size > 1.5 * 1024 * 1024) {
                                window.alert("Tamanho máximo ultrapassado!");
                                refAnexo.current.value = "";
                              } else setAnexo(refAnexo.current?.files[0]);
                            }
                          }}
                        />
                        <small className="form-text text-muted">Tamanho máximo: 1.5MB</small>
                        <div
                          className="invalid-feedback mb-3 bold"
                          style={{ display: refAnexo.current?.files?.length === 0 && sended ? "contents" : "none" }}
                        >
                          <strong>Entre com o anexo! Campo obrigatório.</strong>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {tipoDocumento === "Fatura" && (
                  <>
                    <div className="form-row mb-3">
                      <div className="form-group col-md-8">
                        <label className="mb-2 pr-2 mr-5">Número da Fatura&nbsp;</label>
                        <div
                          className="popup circulo_interrogacao"
                          onClick={() => {
                            setShowNotaHelp(!showNotaHelp);
                          }}
                        >
                          ?
                          <span className={`popuptext ${showNotaHelp ? "show" : ""}`} id="myPopup1">
                            O Número da Fatura é um número gerado pelo fornecedor para identificação do documento.
                          </span>
                        </div>
                        <input
                          type="text"
                          className={`form-control ${numeroNota.length === 0 && sended ? "is-invalid" : "borda-cinza "}`}
                          placeholder="Informe o número da fatura"
                          value={numeroNota}
                          onChange={(e) => setNumeroNota(e.currentTarget.value)}
                        />
                        <div
                          className="invalid-feedback mb-3 bold"
                          style={{ display: numeroNota.length === 0 && sended ? "contents" : "none" }}
                        >
                          <strong>Entre com o número da fatura! Campo obrigatório.</strong>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {InputBoleto}

                <div className="bot-inserir-fatura mt-5 d-flex flex-row-reverse">
                  <button type="submit" className="btn btn-primary">
                    Avançar
                  </button>
                  <button onClick={() => navigate("/listarDocumentos")} className="btn btn-secondary">
                    Voltar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InserirDocumento;
